export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';
export const SET_ACCEPT_LGPD = 'SET_ACCEPT_LGPD';
